import { ForkEffectDescriptor, SimpleEffect, all, call, spawn } from '@redux-saga/core/effects';
import { Saga } from 'redux-saga';
import { LeadSagas } from '@/Lead/sagas';
import { doLogout } from './Auth/sagas';

export default function* rootSaga(): Iterator<unknown> {
    const sagas: Saga[] = [
        LeadSagas,
    ];

    yield all(
        sagas.map((saga: Saga): SimpleEffect<'FORK', ForkEffectDescriptor<unknown>> => {
            return spawn(function*(): Iterator<unknown> {
                try {
                    yield call(saga);

                    return;
                } catch (e: any) {
                    switch (e.name) {
                        case 'JWTExpired':
                            doLogout();
                            (document as any).location = '/';

                            return;
                        default:
                            throw e;
                    }
                }
            });
        }),
    );
}
